import React from "react";
import { Row, Col, Nav, Tab, Container } from "react-bootstrap";
import "./Tabs.css";
import DevelopmentContent from "./DevelopmentContent";

import { Link } from "react-router-dom";

function Tabs() {
  return (
    <Container className="tabs-container">
      <div>
        <h3>The world's largest selection of courses updated everyday</h3>
        <p>Choose from popular video courses released this week</p>
      </div>
      <Tab.Container id="left-tabs-example" defaultActiveKey="development">
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="development">Development</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="business">Business</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="finance">Finance & Accounting</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="software">IT & Software</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="office">Office Productivity</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="personal">Personal Development</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="marketing">Marketing</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="lifestyle">Lifestyle</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="photography">Photography & Video</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="health">Health & Fitness</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="music">Music</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="teaching">Teaching & Academics</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Link to="/Courses">Explore more courses</Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              <Tab.Pane eventKey="development">
                <DevelopmentContent />
              </Tab.Pane>
              <Tab.Pane eventKey="business">Business content</Tab.Pane>
              <Tab.Pane eventKey="finance">Finance content</Tab.Pane>
              <Tab.Pane eventKey="software"> IT & Software content</Tab.Pane>
              <Tab.Pane eventKey="office">Office productivity content</Tab.Pane>
              <Tab.Pane eventKey="personal">
                Personal Development content
              </Tab.Pane>
              <Tab.Pane eventKey="marketing">Marketing content</Tab.Pane>
              <Tab.Pane eventKey="lifestyle">Lifestyle content</Tab.Pane>
              <Tab.Pane eventKey="photography">photography content</Tab.Pane>
              <Tab.Pane eventKey="health">health content</Tab.Pane>
              <Tab.Pane eventKey="music">Music content</Tab.Pane>
              <Tab.Pane eventKey="teaching">
                Teacing & Academics content
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
}

export default Tabs;
